import Advertisement from '@shared/components/Advertisement/Advertisement/Advertisement'
import HomePage from '@shared/components/Advertisement/HomePage/HomePage'
import Rating from '@shared/components/Advertisement/Rating/Rating'
import Faq from '@shared/components/Advertisement/Faq/Faq'
import Plans from '@shared/components/Advertisement/PricingPlans/Plans'

const AdvertisePage = () => {
  return (
    <>
      <main className="advertise-font">
        <HomePage />
        <Advertisement />
        <Rating />
        <Plans />
        <Faq />
      </main>
      {/* <Footer /> */}
    </>
  )
}

export default AdvertisePage
